export default {
  // Header
  "title": "Máy Tạo Pokémon Ngẫu Nhiên",
  "subtitle": "Tạo Pokémon ngẫu nhiên dựa trên sở thích của bạn",
  "home": "Trang chủ",
  "whichPokemonAmI": "Tôi Là Pokemon Nào?",
  "aboutUs": "Về chúng tôi",
  "contactUs": "Liên hệ",
  "privacyPolicy": "Chính sách bảo mật",
  
  // Filters
  "filterTitle": "Tùy Chọn Lọc",
  "generateButton": "Tạo Pokémon Ngẫu Nhiên",
  "generating": "Đang tạo...",
  "numberOfPokemon": "Số lượng Pokémon",
  "type": "Loại",
  "generation": "Thế hệ",
  "minimumRarity": "Độ hiếm tối thiểu (1-10)",
  "anyType": "Bất kỳ loại nào",
  "anyGeneration": "Bất kỳ thế hệ nào",
  "anyRarity": "Bất kỳ độ hiếm nào",
  "countingPokemon": "Đang đếm Pokémon phù hợp",
  "matchingPokemonCount": "{{count}} Pokémon phù hợp với bộ lọc của bạn",
  "noPokemonToDisplay": "Không có Pokémon để hiển thị. Hãy tạo một số Pokémon!",
  
  // Pokemon Types
  "normal": "Bình thường",
  "fire": "Lửa",
  "water": "Nước",
  "electric": "Điện",
  "grass": "Cỏ",
  "ice": "Băng",
  "fighting": "Chiến đấu",
  "poison": "Độc",
  "ground": "Đất",
  "flying": "Bay",
  "psychic": "Siêu linh",
  "bug": "Côn trùng",
  "rock": "Đá",
  "ghost": "Ma",
  "dragon": "Rồng",
  "dark": "Bóng tối",
  "steel": "Thép",
  "fairy": "Tiên",
  
  // Generations
  "Generation I": "Thế hệ I",
  "Generation II": "Thế hệ II",
  "Generation III": "Thế hệ III",
  "Generation IV": "Thế hệ IV",
  "Generation V": "Thế hệ V",
  "Generation VI": "Thế hệ VI",
  "Generation VII": "Thế hệ VII",
  "Generation VIII": "Thế hệ VIII",
  "Generation IX": "Thế hệ IX",
  
  // About Section
  "aboutTitle": "Về Máy Tạo Pokémon Ngẫu Nhiên",
  
  // Section titles
  "introTitle": "Chào mừng đến với Máy Tạo Pokémon Ngẫu Nhiên của chúng tôi",
  "howToUseTitle": "Cách sử dụng Máy Tạo Pokémon Ngẫu Nhiên",
  "benefitsTitle": "Lợi ích khi sử dụng Máy Tạo Pokémon Ngẫu Nhiên của chúng tôi",
  "historyTitle": "Lịch sử Pokémon",
  "popularPokemonTitle": "Những Pokémon phổ biến",
  "popularGamesTitle": "Những game Pokémon phổ biến",
  "tradingContestsTitle": "Giao dịch và Cuộc thi Pokémon",
  "faqTitle": "Câu hỏi thường gặp",
  "conclusionTitle": "Bắt đầu Cuộc phiêu lưu Pokémon Ngẫu nhiên của bạn ngay hôm nay!",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "Pokémon và tên nhân vật Pokémon là thương hiệu của Nintendo.",
  "linksTitle": "Liên kết hữu ích",
  
  // About Us Page
  "aboutUsTitle": "Về chúng tôi",
  "aboutUsWhoWeAre": "Chúng tôi là ai",
  "aboutUsWhoWeAreContent1": "Chào mừng đến với Máy Tạo Pokémon Ngẫu Nhiên, một công cụ được tạo ra bởi những người hâm mộ Pokémon nhiệt thành. Hành trình của chúng tôi bắt đầu vào năm 2023 khi một nhóm các nhà phát triển yêu thích cả lập trình và Pokémon quyết định tạo ra một công cụ hữu ích cho cộng đồng.",
  "aboutUsWhoWeAreContent2": "Đội ngũ của chúng tôi bao gồm các nhà phát triển, nhà thiết kế và người sáng tạo nội dung làm việc cùng nhau để cung cấp trải nghiệm tốt nhất có thể cho người hâm mộ Pokémon trên toàn thế giới.",
  "aboutUsOurMission": "Sứ mệnh của chúng tôi",
  "aboutUsOurMissionContent1": "Chúng tôi hướng đến việc làm cho thế giới Pokémon trở nên dễ tiếp cận và thú vị hơn cho tất cả mọi người. Các công cụ của chúng tôi được thiết kế để giúp các huấn luyện viên khám phá Pokémon mới, tạo ra các đội hình cân bằng và tìm thấy Pokémon phù hợp hoàn hảo của họ.",
  "aboutUsOurMissionContent2": "Chúng tôi cam kết cung cấp trải nghiệm thân thiện với người dùng, chính xác và thú vị, tôn trọng thương hiệu Pokémon đồng thời mang lại giá trị cho cộng đồng.",
  "aboutUsOurTeam": "Đội ngũ của chúng tôi",
  "aboutUsOurTeamContent1": "Đội ngũ đa dạng của chúng tôi kết hợp chuyên môn trong phát triển web, kiến thức về Pokémon, thiết kế trải nghiệm người dùng và quản lý cộng đồng. Chúng tôi đoàn kết bởi tình yêu dành cho Pokémon và cam kết tạo ra các công cụ chất lượng cao.",
  "aboutUsOurTeamContent2": "Mỗi thành viên trong đội ngũ đóng góp kỹ năng và quan điểm độc đáo của họ để làm cho Máy Tạo Pokémon Ngẫu Nhiên trở nên tốt nhất có thể.",
  "aboutUsJoinUs": "Tham gia cùng chúng tôi",
  "aboutUsJoinUsContent": "Chúng tôi luôn tìm kiếm những cá nhân đam mê để tham gia vào cộng đồng của chúng tôi. Cho dù bạn là nhà phát triển, nhà thiết kế, chuyên gia về Pokémon hay người dùng nhiệt tình, ý kiến và đóng góp của bạn đều được chào đón.",
  
  // Contact Us Page
  "contactUsTitle": "Liên hệ",
  "contactUsGetInTouch": "Liên lạc",
  "contactUsGetInTouchContent": "Bạn có câu hỏi, đề xuất hoặc phản hồi về Máy Tạo Pokémon Ngẫu Nhiên? Chúng tôi rất muốn nghe từ bạn! Đây là cách bạn có thể liên hệ với đội ngũ của chúng tôi.",
  "contactUsEmail": "Email",
  "contactUsPhone": "Điện thoại",
  "contactUsAddress": "Địa chỉ",
  "contactUsHelpSupport": "Trợ giúp & Hỗ trợ",
  "contactUsHelpSupportContent": "Cần giúp đỡ sử dụng các công cụ của chúng tôi hoặc gặp phải vấn đề? Đội ngũ hỗ trợ của chúng tôi sẵn sàng giúp đỡ.",
  "contactUsFAQ": "Câu hỏi thường gặp",
  "contactUsFAQContent": "Trước khi liên hệ với chúng tôi, vui lòng kiểm tra phần FAQ của chúng tôi, nơi bao gồm nhiều câu hỏi và vấn đề phổ biến.",
  "contactUsBugReport": "Báo cáo lỗi",
  "contactUsBugReportContent": "Nếu bạn tìm thấy lỗi hoặc vấn đề kỹ thuật, vui lòng thông báo cho chúng tôi bằng cách gửi email với chủ đề 'BÁO CÁO LỖI'.",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "Chính sách bảo mật",
  "privacyPolicyIntro": "Giới thiệu",
  "privacyPolicyIntroContent": "Tại Máy Tạo Pokémon Ngẫu Nhiên, chúng tôi tôn trọng quyền riêng tư của bạn và cam kết bảo vệ dữ liệu cá nhân của bạn. Chính sách Bảo mật này giải thích cách chúng tôi thu thập, sử dụng và bảo vệ thông tin của bạn khi bạn sử dụng trang web của chúng tôi.",
  "privacyPolicyInformation": "Thông tin chúng tôi thu thập",
  "privacyPolicyInformationContent": "Chúng tôi thu thập thông tin tối thiểu để cung cấp và cải thiện dịch vụ của mình. Điều này có thể bao gồm:",
  "privacyPolicyInformationItem1": "Dữ liệu sử dụng (như các trang đã truy cập, thời gian dành cho trang web và tính năng đã sử dụng)",
  "privacyPolicyInformationItem2": "Thông tin thiết bị (loại trình duyệt, hệ điều hành và độ phân giải màn hình)",
  "privacyPolicyInformationItem3": "Địa chỉ IP và vị trí gần đúng (chỉ ở cấp quốc gia)",
  "privacyPolicyCookies": "Cookie và công nghệ tương tự",
  "privacyPolicyCookiesContent": "Chúng tôi sử dụng cookie để cải thiện trải nghiệm của bạn trên trang web của chúng tôi. Các tệp văn bản nhỏ này cho phép chúng tôi ghi nhớ tùy chọn của bạn và phân tích việc sử dụng trang web của chúng tôi. Bạn có thể kiểm soát cookie thông qua cài đặt trình duyệt của mình.",
  "privacyPolicyThirdParty": "Dịch vụ của bên thứ ba",
  "privacyPolicyThirdPartyContent": "Trang web của chúng tôi có thể sử dụng các dịch vụ của bên thứ ba như nhà cung cấp phân tích và mạng phân phối nội dung. Các dịch vụ này có thể thu thập thông tin về việc bạn sử dụng trang web của chúng tôi. Chúng tôi đảm bảo rằng tất cả các bên thứ ba tôn trọng quyền riêng tư của bạn và xử lý dữ liệu một cách thích hợp.",
  "privacyPolicySecurity": "Bảo mật dữ liệu",
  "privacyPolicySecurityContent": "Chúng tôi thực hiện các biện pháp bảo mật thích hợp để bảo vệ thông tin của bạn khỏi truy cập, thay đổi hoặc tiết lộ trái phép. Tuy nhiên, không có phương thức truyền tải nào qua Internet là an toàn 100%, vì vậy chúng tôi không thể đảm bảo an ninh tuyệt đối.",
  "privacyPolicyChanges": "Thay đổi đối với Chính sách này",
  "privacyPolicyChangesContent": "Chúng tôi có thể cập nhật Chính sách Bảo mật của mình theo thời gian. Chúng tôi sẽ thông báo cho bạn về bất kỳ thay đổi nào bằng cách đăng Chính sách Bảo mật mới trên trang này và cập nhật ngày 'cập nhật lần cuối'.",
  "privacyPolicyContact": "Liên hệ chúng tôi",
  "privacyPolicyContactContent": "Nếu bạn có bất kỳ câu hỏi nào về Chính sách Bảo mật này, vui lòng liên hệ với chúng tôi thông qua thông tin được cung cấp trên trang Liên hệ của chúng tôi.",
  "privacyPolicyLastUpdated": "Cập nhật lần cuối",
  
  // Which Pokemon Am I Page
  "whichPokemonAmITitle": "Tôi Là Pokemon Nào?",
  "whichPokemonAmISubtitle": "Khám phá Pokemon nào phù hợp nhất với bạn",
  "enterYourName": "Nhập tên của bạn",
  "namePlaceholder": "Tên của bạn",
  "enterFavoriteColor": "Chọn màu yêu thích của bạn",
  "enterBirthMonth": "Chọn tháng sinh của bạn",
  "selectBirthMonth": "Chọn tháng",
  "enterPersonalityTrait": "Chọn đặc điểm tính cách của bạn",
  "selectPersonalityTrait": "Chọn đặc điểm",
  "findMyPokemon": "Tìm Pokemon của tôi",
  "calculating": "Đang tính toán...",
  "yourPokemonIs": "Pokemon của bạn là",
  "pokemonDescription": "Mô tả",
  "personalityMatch": "Phù hợp tính cách",
  "yourCompatibility": "Sự tương thích của bạn",
  "downloadImage": "Tải xuống hình ảnh",
  "shareResult": "Chia sẻ kết quả",
  "tryAgain": "Thử lại",
  "results": "Kết quả",
  "aboutTool": "Về Công Cụ Này",
  "howToUse": "Cách Sử Dụng",
  "benefits": "Lợi Ích",
  "faq": "Câu Hỏi Thường Gặp",
  "conclusion": "Kết Luận",
  
  // Error messages
  "nameRequired": "Tên là bắt buộc",
  "colorRequired": "Vui lòng chọn một màu",
  "monthRequired": "Vui lòng chọn một tháng",
  "traitRequired": "Vui lòng chọn một đặc điểm tính cách",
  
  // Months
  "january": "Tháng Một",
  "february": "Tháng Hai",
  "march": "Tháng Ba",
  "april": "Tháng Tư",
  "may": "Tháng Năm",
  "june": "Tháng Sáu",
  "july": "Tháng Bảy",
  "august": "Tháng Tám",
  "september": "Tháng Chín",
  "october": "Tháng Mười",
  "november": "Tháng Mười Một",
  "december": "Tháng Mười Hai",
  
  // Personality Traits
  "brave": "Dũng Cảm",
  "calm": "Điềm Tĩnh",
  "timid": "Nhút Nhát",
  "jolly": "Vui Vẻ",
  "quiet": "Yên Lặng",
  "hasty": "Hấp Tấp",
  "careful": "Cẩn Thận",
  "lonely": "Cô Đơn",
  "bold": "Táo Bạo",
  "relaxed": "Thư Giãn",
  "impish": "Nghịch Ngợm",
  "modest": "Khiêm Tốn",
  
  // Additional translations for size matching feature
  "heightValid": "Vui lòng nhập chiều cao hợp lệ (1-300 cm)",
  "weightValid": "Vui lòng nhập cân nặng hợp lệ (1-500 kg)",
  "enterDetails": "Nhập thông tin chi tiết của bạn",
  "nameLabel": "Tên",
  "heightLabel": "Chiều cao",
  "weightLabel": "Cân nặng",
  "finding": "Đang tìm kiếm...",
  "errorFinding": "Lỗi khi tìm Pokemon của bạn",
  "matchResult": "Pokemon {{name}} là...",
  "similarityScore": "Điểm tương đồng",
  "downloadStarted": "Đang chuẩn bị hình ảnh...",
  "downloadComplete": "Tải xuống hình ảnh thành công!",
  "shareText": "Tôi phát hiện ra mình là {{pokemon}}! Tìm ra bạn là Pokemon nào!",
  
  // Size matching feature
  "enterHeightWeight": "Nhập chiều cao và cân nặng của bạn — xem Pokémon nào phù hợp với bạn!",
  "whichPokemonMatchesSize": "Pokémon nào phù hợp với kích thước của bạn?",
  "youAreMostLike": "Bạn giống nhất với",
  
  // Evolution Stage
  "evolutionStage": "Giai đoạn Tiến hóa",
  "evolutionStageAll": "Tất cả Giai đoạn",
  "evolutionStageFullyEvolved": "Tiến hóa Hoàn toàn",
  "evolutionStageNotFullyEvolved": "Chưa Tiến hóa Hoàn toàn",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Vietnamese)
  "pokemonRandomizerPageAboutTitle": "Khám phá Trải nghiệm Tối thượng của Bộ tạo Ngẫu nhiên Pokémon",
  "pokemonRandomizer_whatIsItTitle": "Bộ tạo Ngẫu nhiên Pokémon Chính xác là Gì?",
  "pokemonRandomizer_featuresTitle": "Các Tính năng Chính của Công cụ Tạo Ngẫu nhiên Pokémon Của Chúng Tôi",
  "pokemonRandomizer_whyUseTitle": "Tại sao Bắt đầu một Cuộc Phiêu lưu với Bộ tạo Ngẫu nhiên Pokémon?",
  "pokemonRandomizer_gettingStartedTitle": "Bắt đầu: Lần Chạy Bộ tạo Ngẫu nhiên Pokémon Đầu tiên Của Bạn",
  "pokemonRandomizer_faqTitle": "Bộ tạo Ngẫu nhiên Pokémon: Các Câu hỏi Thường Gặp",
  "contact": "Liên hệ",
  "contactText": "Bạn có câu hỏi hoặc đề xuất? Hãy liên hệ với chúng tôi qua",
  "discordServer": "Máy chủ Discord",
  "twitter": "Twitter",
  "github": "GitHub",
  "buyMeACoffee": "Mua cho tôi một ly cà phê",
  "pokemonRandomizerPageH1": "Trình ngẫu nhiên Pokémon",
  "pokemonRandomizerPageSubtitle": "Tạo ra những trải nghiệm Pokémon độc đáo bằng cách ngẫu nhiên hóa thế hệ Pokémon, loại, và nhiều hơn nữa.",

  // Sub-Footer
  subFooterToolsTitle: "Công cụ",
  subFooterRandomPokemonGeneratorLink: "Trình tạo Pokémon Ngẫu nhiên",
  subFooterPokemonRandomizerLink: "Trình ngẫu nhiên Pokémon",
  subFooterWhichPokemonAmILink: "Tôi Là Pokémon Nào?",

  subFooterPokemonDatabaseTitle: "Cơ sở dữ liệu Pokémon",
  subFooterPokedexLink: "Pokédex (Sắp ra mắt)",
  subFooterTypeChartsLink: "Bảng loại (Sắp ra mắt)",
  subFooterMoveListLink: "Danh sách chiêu thức (Sắp ra mắt)",

  subFooterBlogTitle: "Blog",
  subFooterLatestArticlesLink: "Bài viết mới nhất (Sắp ra mắt)",
  subFooterGuidesTutorialsLink: "Hướng dẫn & Bài hướng dẫn (Sắp ra mắt)"
};
